import React from 'react';
import { Collapse, List } from '@mui/material';
import { useSidebar } from '../hook/useSidebar';
import SidebarItem from '../SidebarItem';
import SidebarItemExpendable from '../SidebarItemExpendable';
import { AppRegistration } from '@mui/icons-material';
import { usePermissionRules } from 'hooks/permissionRules';

const Registrations: React.FC = () => {
  const { handleCollapseClick, collapsible } = useSidebar();
  const { checkPermission } = usePermissionRules();

  return (
    <>
      <SidebarItemExpendable
        onClick={() => handleCollapseClick('registrations')}
        text="Cadastros"
        opened={collapsible.registrations}
        icon={<AppRegistration />}
      />
      <Collapse in={collapsible.registrations}>
        <List disablePadding>
          {checkPermission('registrations.specialties') && (
            <SidebarItem nested={5} to="/specialties" text="Especialidades" />
          )}
          {checkPermission('registrations.payment-methods') && (
            <SidebarItem nested={5} to="/payment-methods" text="Formas de recebimento" />
          )}
          {checkPermission('registrations.suppliers') && <SidebarItem nested={5} to="/suppliers" text="Fornecedores" />}
          {checkPermission('registrations.hospitals') && <SidebarItem nested={5} to="/hospitals" text="Hospitais" />}
          {checkPermission('registrations.doctors') && <SidebarItem nested={5} to="/doctors" text="Médicos" />}
          {checkPermission('registrations.patients') && <SidebarItem nested={5} to="/patients" text="Pacientes" />}
          {checkPermission('registrations.packages') && <SidebarItem nested={5} to="/packages" text="Pacotes" />}
          {checkPermission('registrations.procedures') && (
            <SidebarItem nested={5} to="/procedures" text="Procedimentos" />
          )}
          {checkPermission('registrations.products') && <SidebarItem nested={5} to="/products" text="Produtos" />}
        </List>
      </Collapse>
    </>
  );
};

export default Registrations;
